import React from 'react';

import {SvgProps} from '../../helpers/type';

const Stock = ({className}: SvgProps): JSX.Element => {
    return (
        <svg
            width="46"
            height="46"
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect
                x="0.712988"
                y="0.7125"
                width="44.175"
                height="44.175"
                rx="9.42083"
                fill="#EDFCF2"
                fillOpacity="0.5"
            />
            <path
                d="M26.2839 15.1998L29.1845 18.1005L23.0032 24.2818L17.9365 19.2152L8.55054 28.6138L10.3365 30.3998L17.9365 22.7998L23.0032 27.8665L30.9832 19.8992L33.8839 22.7998V15.1998H26.2839Z"
                fill="#5D847F"
            />
            <rect
                x="0.712988"
                y="0.7125"
                width="44.175"
                height="44.175"
                rx="9.42083"
                stroke="#E8EDEC"
                strokeWidth="1.425"
            />
        </svg>
    );
};

export default Stock;
